import React from 'react';
import PropTypes from 'prop-types';
import {setUrlSearchParams} from "../../../../helpers/UrlHelper";
import ViewClinicLink from "../../../Links/ViewClinicLink";

const ClinicLinkCell = React.memo(({cell: {value}, from, className, queryParams = {}}) => {
    const search = setUrlSearchParams(undefined, queryParams);
    const name = value ? value.name : null;
    return (
        <React.Fragment>
            {
                value.isClinic ?
                    <ViewClinicLink
                        className={className}
                        id={value.id}
                        from={from}
                        search={search}>
                        {value.name}
                    </ViewClinicLink>
                    :
                    name ? <span className={className}>{name}</span> : null
            }
        </React.Fragment>
    )
});

ClinicLinkCell.propTypes = {
    from: PropTypes.string,
    queryParams: PropTypes.object,
};

export default ClinicLinkCell;
